import React from 'react';
import cs from 'classnames';

import css from './index.css';

const LoadingSpiner = () => (
  <div className={css.spinner}>
    <div className={cs(css.spinnerContainer, css.container1)}>
      <div className={css.circle1} />
      <div className={css.circle2} />
      <div className={css.circle3} />
      <div className={css.circle4} />
    </div>
    <div className={cs(css.spinnerContainer, css.container2)}>
      <div className={css.circle1} />
      <div className={css.circle2} />
      <div className={css.circle3} />
      <div className={css.circle4} />
    </div>
    <div className={cs(css.spinnerContainer, css.container3)}>
      <div className={css.circle1} />
      <div className={css.circle2} />
      <div className={css.circle3} />
      <div className={css.circle4} />
    </div>
  </div>
);

export default LoadingSpiner;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/LoadingSpiner/index.js